import React from "react";
import { Typography, useTheme } from "@mui/material";
import { Underline } from "../";

function Heading({
	headingType = "h2",
	children,
	variant,
	underline,
	anchor = null,
	isSidebar = false,
}) {
	const theme = useTheme();
	underline =
		underline ||
		(isSidebar && theme.palette.sidebarUnderline
			? theme.palette.sidebarUnderline
			: null);
	variant = variant || headingType;
	function Wrapper({ children }) {
		return headingType === "h1" ? <header>{children}</header> : <>{children}</>;
	}
	return (
		<Wrapper>
			<Typography
				className={`heading-${headingType}`}
				variant={variant}
				component={headingType}
				id={anchor}
			>
				{children}
				{underline && <Underline color={underline} />}
			</Typography>
		</Wrapper>
	);
}

export default Heading;
